export const BidIcon = () => (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.3496 0.349976L5.60582 5.0551C5.50637 5.12158 5.43934 5.15375 5.33555 5.15375C5.25339 5.15375 5.17772 5.11301 5.07177 5.03366L0.349609 0.349976V10.35L5.11285 5.62769C5.19285 5.57837 5.26204 5.55264 5.35501 5.55264C5.44799 5.55264 5.53231 5.59982 5.64907 5.68774L10.3496 10.35V0.349976Z"
            stroke="#181D27" strokeWidth="0.7" strokeLinejoin="round"/>
    </svg>
);